// eslint-disable-next-line import/no-extraneous-dependencies
import '@ckeditor/ckeditor5-list/dist/index.css';
import { FC } from 'react';
import { CloseButton, Drawer, Stack, Text } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { DateTimeDisplay } from '~/core/shared/components/DateTimeDisplay';
import { DocumentMessage } from '~/core/shared/types';
import sanitiseHtml from '~/core/shared/utils/sanitiseHtml';

type MessageViewDrawerProps = {
  drawerApi: UseOpenCloseReturn;
  message: DocumentMessage;
};

export const MessageViewDrawer: FC<MessageViewDrawerProps> = ({
  drawerApi,
  message,
}) => (
  <Drawer.Root
    onOpenChange={drawerApi.onOpenChange}
    open={drawerApi.open}
    placement="end"
    size="md"
  >
    <Drawer.Backdrop />
    <Drawer.Positioner>
      <Drawer.Content>
        <Drawer.CloseTrigger asChild>
          <CloseButton />
        </Drawer.CloseTrigger>
        <Drawer.Header borderBottomWidth="1px">View Message</Drawer.Header>

        <Drawer.Body p={6}>
          <Stack gap={8}>
            <Stack>
              <Text fontWeight="bold">Sent:</Text>
              <Text>
                <DateTimeDisplay value={message.createdAt} />
                {` by ${message.createdBy}`}
              </Text>
            </Stack>

            <Stack>
              <Text fontWeight="bold">Category:</Text>
              <Text textTransform="capitalize">{message.category}</Text>
            </Stack>

            <Stack>
              <Text fontWeight="bold">Private:</Text>
              <Text>{message.private ? 'Yes' : 'No'}</Text>
            </Stack>

            <Stack>
              <Text fontWeight="bold">Subject:</Text>
              <Text>
                {message.subject} {' - '}
                <DateTimeDisplay value={message.createdAt} />
              </Text>
            </Stack>

            <Stack className="messageContentPreview">
              <Text fontWeight="bold">Message text:</Text>

              <div className="ck-content">{sanitiseHtml(message.content)}</div>
            </Stack>
          </Stack>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Positioner>
  </Drawer.Root>
);
